module.exports = __webpack_public_path__ + "static/bg01-336dd12de58ba2349aa4b4a508e04ae1.jpg";